import { render, staticRenderFns } from "./TabShareLineBreaksNumber.vue?vue&type=template&id=cb591cc4&scoped=true&"
import script from "./TabShareLineBreaksNumber.vue?vue&type=script&lang=js&"
export * from "./TabShareLineBreaksNumber.vue?vue&type=script&lang=js&"
import style0 from "./TabShareLineBreaksNumber.vue?vue&type=style&index=0&id=cb591cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb591cc4",
  null
  
)

export default component.exports